import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isPortalAudioMuted, setPortalAudioMuted } from "@/lib/portalAudio";

/**
 * Small speaker toggle for the portal transition sound. Preference lives in
 * sessionStorage so it survives navigation but resets in a new tab.
 * Sits in the bottom-right corner of the hero, deliberately understated.
 */
export default function SoundToggle() {
    const [muted, setMuted] = useState(false);

    useEffect(() => {
        setMuted(isPortalAudioMuted());
    }, []);

    const toggle = () => {
        const next = !muted;
        setMuted(next);
        setPortalAudioMuted(next);
    };

    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="portal-sound-toggle"
            aria-label={muted ? "Turn portal sound on" : "Turn portal sound off"}
            title={muted ? "Portal sound is off" : "Portal sound is on"}
            className="fixed bottom-6 right-6 z-30 w-9 h-9 rounded-full border border-[var(--border-subtle)] bg-black/40 backdrop-blur-md text-[var(--accent-champagne)]/70 hover:text-[var(--accent-champagne)] hover:border-[var(--border-accent)] flex items-center justify-center transition-colors"
        >
            {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}
        </button>
    );
}
